import template from './order-history.html';
import controller from './order-history.controller';
import './order-history.less';

let orderHistoryComponent = {
    restrict: 'E',
    bindings: {orderHistoryModel: '<'},
    template,
    controller
};

export default orderHistoryComponent;


// WEBPACK FOOTER //
// ./src/app/components/order-history/order-history.component.js